/** Identifiant de la zone de contenu (`main` de la coquille), cible du lien d'évitement. */
export const ID_CONTENU = 'contenu'

/**
 * Spec 160 (FR-011, WCAG 2.4.1) — premier arrêt clavier de chaque page : il saute le menu et la barre du haut.
 * Invisible jusqu'au focus. Le focus est posé à la main : laisser le navigateur suivre l'ancre ajouterait `#contenu`
 * à l'adresse et une entrée d'historique.
 */
export function LienEvitement() {
  return (
    <a
      href={`#${ID_CONTENU}`}
      onClick={e => {
        e.preventDefault()
        document.getElementById(ID_CONTENU)?.focus()
      }}
      className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded-sm focus:bg-card focus:px-3 focus:py-2 focus:text-primary focus:outline-none focus:ring-2 focus:ring-ring"
      style={{ fontFamily: 'var(--font-body)', fontSize: 'var(--fs-body)' }}
    >
      Aller au contenu
    </a>
  )
}
